import { atom } from '@reatom/framework'

import { UserTradingAnalyticsPeriod } from '@root/features/user/user-trading-analytics/models'

import type { NotificationWidget, NotificationWidgetVariant } from '../model'
import type { Summary } from '@root/entities/summary/model'
import type { Transaction } from '@root/entities/transaction/model'

export const notificationWidgetsLayoutAtom = atom<
  Array<{
    widget: NotificationWidget
    variant: NotificationWidgetVariant
    order: number
  }>
>(
  [
    {
      widget: 'profile',
      variant: 'square',
      order: 0,
    },
    {
      widget: 'wallets',
      variant: 'square',
      order: 1,
    },
    {
      widget: 'txs',
      variant: 'row',
      order: 2,
    },
  ],
  'notificationWidgetsLayoutAtom',
)

type NotificationProfileWidget = {
  period: UserTradingAnalyticsPeriod
  pnlUsd: number | undefined
  pnlPercents: number | undefined
}

// TODO: user profile stats model
export const notificationProfileWidgetAtom = atom<NotificationProfileWidget>(
  {
    period: UserTradingAnalyticsPeriod['1H'],
    pnlUsd: undefined,
    pnlPercents: undefined,
  },
  'notificationProfileWidgetAtom',
)

export const notificationProfileWidgetChartDataAtom = atom<
  Array<Summary.DataEntry>
>([], 'notificationProfileWidgetChartDataAtom')
export const notificationTxsWidgetAtom = atom<Array<Transaction.Transaction>>(
  [],
  'notificationTxsWidgetAtom',
)
